module.exports = __webpack_public_path__ + "img/arrow-up-icon-white.8a4ddd1e.svg";